/*
  Mobile collapse for the Blog link columns section.

  Progressive enhancement: the CSS only collapses a card once this script has
  added the --collapse-ready class to it. If the script never runs, cards stay
  fully expanded and the whole-card link keeps working as it does on desktop.

  The collapse never takes the card's tap target away: tapping the card goes to
  the article, collapsed or not. Only the toggle button expands and collapses,
  and it sits above the stretched card link (z-index in the CSS) so its own
  click never reaches that link.
*/
(function () {
  const MOBILE = '(max-width: 749px)';
  const READY = 'blog-link-columns__card--collapse-ready';

  function markReady(root) {
    (root || document)
      .querySelectorAll('.blog-link-columns__card--collapsible')
      .forEach(function (card) {
        if (card.querySelector('.blog-link-columns__toggle')) {
          card.classList.add(READY);
        }
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      markReady();
    });
  } else {
    markReady();
  }

  // Sections re-render in the theme editor without a page load.
  document.addEventListener('shopify:section:load', function (event) {
    markReady(event.target);
  });

  document.addEventListener('click', function (event) {
    const toggle = event.target.closest('.blog-link-columns__toggle');
    if (!toggle) return;

    const card = toggle.closest('.' + READY);
    if (!card) return;
    if (!window.matchMedia(MOBILE).matches) return;

    // Stop the tap here so it can't fall through to the card link behind it.
    event.preventDefault();
    event.stopPropagation();

    const isOpen = card.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', String(isOpen));
  });
})();